<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Accumulation Type</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Accumulation Type</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Accumulation Type</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex class="mt-3" xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newMode">
                <v-text-field
                  v-model="accumTypeForm.accmType"
                  :label="labels.accmType"
                  :error-messages="errors.collect('accmType')"
                  data-vv-name="accmType"
                  :data-vv-as="labels.accmType"
                  v-validate="'required|param|max:2'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.accmType }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.accmTypeDesc }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.accmTypeDesc }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="accumTypeForm.accmTypeDesc"
                  :label="labels.accmTypeDesc"
                  :error-messages="errors.collect('accmTypeDesc')"
                  data-vv-name="accmTypeDesc"
                  :data-vv-as="labels.accmTypeDesc"
                  v-validate="'required|max:50'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <br />
            <!-- Block Group Label -->
            <v-layout row wrap>
              <v-flex>
                <v-flex v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.blkGrpLblS }}</v-subheader>
                  <div class="queryValue">{{ accumTypeForm.blkGrpLblS }}</div>
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="accumTypeForm.blkGrpLblS"
                    :label="labels.blkGrpLblS"
                    :error-messages="errors.collect('blkGrpLblS')"
                    data-vv-name="blkGrpLblS"
                    :data-vv-as="labels.blkGrpLblS"
                    v-validate="'max:50'"
                  ></v-text-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.defBlkGrpAE" :label="labels.defBlkGrpAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.accumTypeForm.blkGrpLblS === ''"
                      v-model="accumTypeForm.defBlkGrpAE"
                      :label="labels.defBlkGrpAE"
                      :error-messages="errors.collect('defBlkGrpAE')"
                      data-vv-name="defBlkGrpAE"
                      :data-vv-as="labels.defBlkGrpAE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.protBlkGrpAE" :label="labels.protBlkGrpAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.disableBlockGroupLabelByShortAndDef === true"
                      v-model="accumTypeForm.protBlkGrpAE"
                      :label="labels.protBlkGrpAE"
                      :error-messages="errors.collect('protBlkGrpAE')"
                      data-vv-name="protBlkGrpAE"
                      :data-vv-as="labels.protBlkGrpAE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.blkGrpLblL }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.blkGrpLblL }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-textarea
                  v-bind:readonly="this.accumTypeForm.blkGrpLblS === ''"
                  v-model="accumTypeForm.blkGrpLblL"
                  :label="labels.blkGrpLblL"
                  :error-messages="errors.collect('blkGrpLblL')"
                  data-vv-name="blkGrpLblL"
                  :data-vv-as="labels.blkGrpLblL"
                  v-validate="'max:200'"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.nxtBlkGrpSeq }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.nxtBlkGrpSeq }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-bind:readonly="this.disableBlockGroupLabelByShortAndDef === true"
                  v-model="accumTypeForm.nxtBlkGrpSeq"
                  :label="labels.nxtBlkGrpSeq"
                  :error-messages="errors.collect('nxtBlkGrpSeq')"
                  data-vv-name="nxtBlkGrpSeq"
                  :data-vv-as="labels.nxtBlkGrpSeq"
                  v-validate="'required|mask_decimal:0'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <br />
            <!-- Block Sub Group 1 Label -->
            <v-layout row wrap>
              <v-flex>
                <v-flex v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.blkSgrp1LblS }}</v-subheader>
                  <div class="queryValue">{{ accumTypeForm.blkSgrp1LblS }}</div>
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="accumTypeForm.blkSgrp1LblS"
                    :label="labels.blkSgrp1LblS"
                    :error-messages="errors.collect('blkSgrp1LblS')"
                    data-vv-name="blkSgrp1LblS"
                    :data-vv-as="labels.blkSgrp1LblS"
                    v-validate="'max:50'"
                  ></v-text-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.defBlkSgrp1AE" :label="labels.defBlkSgrp1AE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.accumTypeForm.blkSgrp1LblS === ''"
                      v-model="accumTypeForm.defBlkSgrp1AE"
                      :label="labels.defBlkSgrp1AE"
                      :error-messages="errors.collect('defBlkSgrp1AE')"
                      data-vv-name="defBlkSgrp1AE"
                      :data-vv-as="labels.defBlkSgrp1AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.protBlkSgrp1AE" :label="labels.protBlkSgrp1AE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.disableBlockSubGroup1LabelByShortAndDef === true"
                      v-model="accumTypeForm.protBlkSgrp1AE"
                      :label="labels.protBlkSgrp1AE"
                      :error-messages="errors.collect('protBlkSgrp1AE')"
                      data-vv-name="protBlkSgrp1AE"
                      :data-vv-as="labels.protBlkSgrp1AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.blkSgrp1LblL }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.blkSgrp1LblL }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-textarea
                  v-bind:readonly="this.accumTypeForm.blkSgrp1LblS === ''"
                  v-model="accumTypeForm.blkSgrp1LblL"
                  :label="labels.blkSgrp1LblL"
                  :error-messages="errors.collect('blkSgrp1LblL')"
                  data-vv-name="blkSgrp1LblL"
                  :data-vv-as="labels.blkSgrp1LblL"
                  v-validate="'max:200'"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.nxtBlkSgrp1Seq }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.nxtBlkSgrp1Seq }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-bind:readonly="this.disableBlockSubGroup1LabelByShortAndDef === true"
                  v-model="accumTypeForm.nxtBlkSgrp1Seq"
                  :label="labels.nxtBlkSgrp1Seq"
                  :error-messages="errors.collect('nxtBlkSgrp1Seq')"
                  data-vv-name="nxtBlkSgrp1Seq"
                  :data-vv-as="labels.nxtBlkSgrp1Seq"
                  v-validate="'required|mask_decimal:0'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <br />
            <!-- BLock Sub Group 2 Label -->
            <v-layout row wrap>
              <v-flex>
                <v-flex v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.blkSgrp2LblS }}</v-subheader>
                  <div class="queryValue">{{ accumTypeForm.blkSgrp2LblS }}</div>
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="accumTypeForm.blkSgrp2LblS"
                    :label="labels.blkSgrp2LblS"
                    :error-messages="errors.collect('blkSgrp2LblS')"
                    data-vv-name="blkSgrp2LblS"
                    :data-vv-as="labels.blkSgrp2LblS"
                    v-validate="'max:50'"
                  ></v-text-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.defBlkSgrp2AE" :label="labels.defBlkSgrp2AE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.accumTypeForm.blkSgrp2LblS === ''"
                      v-model="accumTypeForm.defBlkSgrp2AE"
                      :label="labels.defBlkSgrp2AE"
                      :error-messages="errors.collect('defBlkSgrp2AE')"
                      data-vv-name="defBlkSgrp2AE"
                      :data-vv-as="labels.defBlkSgrp2AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.protBlkSgrp2AE" :label="labels.protBlkSgrp2AE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.disableBlockSubGroup2LabelByShortAndDef === true"
                      v-model="accumTypeForm.protBlkSgrp2AE"
                      :label="labels.protBlkSgrp2AE"
                      :error-messages="errors.collect('protBlkSgrp2AE')"
                      data-vv-name="protBlkSgrp2AE"
                      :data-vv-as="labels.protBlkSgrp2AE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.blkSgrp2LblL }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.blkSgrp2LblL }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-textarea
                  v-bind:readonly="this.accumTypeForm.blkSgrp2LblS === ''"
                  v-model="accumTypeForm.blkSgrp2LblL"
                  :label="labels.blkSgrp2LblL"
                  :error-messages="errors.collect('blkSgrp2LblL')"
                  data-vv-name="blkSgrp2LblL"
                  :data-vv-as="labels.blkSgrp2LblL"
                  v-validate="'max:200'"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.nxtBlkSgrp2Seq }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.nxtBlkSgrp2Seq }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-bind:readonly="this.disableBlockSubGroup2LabelByShortAndDef === true"
                  v-model="accumTypeForm.nxtBlkSgrp2Seq"
                  :label="labels.nxtBlkSgrp2Seq"
                  :error-messages="errors.collect('nxtBlkSgrp2Seq')"
                  data-vv-name="nxtBlkSgrp2Seq"
                  :data-vv-as="labels.nxtBlkSgrp2Seq"
                  v-validate="'required|mask_decimal:0'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <br />
            <!-- Block Label -->
            <v-layout row wrap>
              <v-flex>
                <v-flex v-if="queryMode">
                  <v-subheader class="queryLabel">{{ labels.blkLblS }}</v-subheader>
                  <div class="queryValue">{{ accumTypeForm.blkLblS }}</div>
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="accumTypeForm.blkLblS"
                    :label="labels.blkLblS"
                    :error-messages="errors.collect('blkLblS')"
                    data-vv-name="blkLblS"
                    :data-vv-as="labels.blkLblS"
                    v-validate="'max:50'"
                  ></v-text-field>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.defBlkAE" :label="labels.defBlkAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.accumTypeForm.blkLblS === ''"
                      v-model="accumTypeForm.defBlkAE"
                      :label="labels.defBlkAE"
                      :error-messages="errors.collect('defBlkAE')"
                      data-vv-name="defBlkAE"
                      :data-vv-as="labels.defBlkAE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-if="queryMode">
                    <v-checkbox readonly v-model="accumTypeForm.protBlkAE" :label="labels.protBlkAE"></v-checkbox>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-checkbox
                      v-bind:readonly="this.disableBlockLabelByShortAndDef === true"
                      v-model="accumTypeForm.protBlkAE"
                      :label="labels.protBlkAE"
                      :error-messages="errors.collect('protBlkAE')"
                      data-vv-name="protBlkAE"
                      :data-vv-as="labels.protBlkAE"
                      v-validate="'required'"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.blkLblL }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.blkLblL }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-textarea
                  v-bind:readonly="this.accumTypeForm.blkLblS === ''"
                  v-model="accumTypeForm.blkLblL"
                  :label="labels.blkLblL"
                  :error-messages="errors.collect('blkLblL')"
                  data-vv-name="blkLblL"
                  :data-vv-as="labels.blkLblL"
                  v-validate="'max:200'"
                  auto-grow
                  rows="1"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.nxtBlkSeq }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.nxtBlkSeq }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-bind:readonly="this.disableBlockLabelByShortAndDef === true"
                  v-model="accumTypeForm.nxtBlkSeq"
                  :label="labels.nxtBlkSeq"
                  :error-messages="errors.collect('nxtBlkSeq')"
                  data-vv-name="nxtBlkSeq"
                  :data-vv-as="labels.nxtBlkSeq"
                  v-validate="'required|mask_decimal:0'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <br />
            <!-- Key Factor 1 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey1 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention1" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey1"
                  :items="rtnLimKey123List"
                  v-model="accumTypeForm.rtnLimKey1"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey1"
                  :data-vv-as="labels.rtnLimKey1"
                  :error-messages="errors.collect('rtnLimKey1')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Treaty/Quota Share</v-flex>
            </v-layout>

            <!-- Key Factor 2 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey2 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention2" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey2"
                  :items="rtnLimKey123List"
                  v-model="accumTypeForm.rtnLimKey2"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey2"
                  :data-vv-as="labels.rtnLimKey2"
                  :error-messages="errors.collect('rtnLimKey2')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Treaty/Quota Share</v-flex>
            </v-layout>

            <!-- Key Factor 3 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey3 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention3" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey3"
                  :items="rtnLimKey123List"
                  v-model="accumTypeForm.rtnLimKey3"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey3"
                  :data-vv-as="labels.rtnLimKey3"
                  :error-messages="errors.collect('rtnLimKey3')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Treaty/Quota Share</v-flex>
            </v-layout>

            <!-- Key Factor 4 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey4 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention4" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey4"
                  :items="rtnLimKey456List"
                  v-model="accumTypeForm.rtnLimKey4"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey4"
                  :data-vv-as="labels.rtnLimKey4"
                  :error-messages="errors.collect('rtnLimKey4')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Statutory</v-flex>
            </v-layout>

            <!-- Key Factor 5 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey5 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention5" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey5"
                  :items="rtnLimKey456List"
                  v-model="accumTypeForm.rtnLimKey5"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey5"
                  :data-vv-as="labels.rtnLimKey5"
                  :error-messages="errors.collect('rtnLimKey5')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Statutory</v-flex>
            </v-layout>

            <!-- Key Factor 6 -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.rtnLimKey6 }}</v-subheader>
                <div class="queryValue" v-for="item in filterRetention6" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.rtnLimKey6"
                  :items="rtnLimKey456List"
                  v-model="accumTypeForm.rtnLimKey6"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rtnLimKey6"
                  :data-vv-as="labels.rtnLimKey6"
                  :error-messages="errors.collect('rtnLimKey6')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>* Applicable for Statutory</v-flex>
            </v-layout>

            <!-- Apply Limit CheckBox -->
            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-checkbox readonly v-model="accumTypeForm.useLimType" :label="labels.useLimType"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-else>
                <v-checkbox
                  v-model="accumTypeForm.useLimType"
                  :label="labels.useLimType"
                  :error-messages="errors.collect('useLimType')"
                  data-vv-name="useLimType"
                  :data-vv-as="labels.useLimType"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(accumTypeForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ accumTypeForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(accumTypeForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
            <!-- Buttons -->
            <v-layout row wrap>
              <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
                <span>Cancel</span>
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" @click="doSave" :loading="submitting">
                <span>Save</span>
                <v-icon right dark>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        accmType: 'Accumulation Type*',
        accmTypeDesc: 'Description*',
        blkGrpLblL: 'Block Group Label, Long',
        blkGrpLblS: 'Block Group Label, Short',
        blkSgrp1LblS: 'Block Sub Group 1 Label, Short',
        blkSgrp1LblL: 'Block Sub Group 1 Label, Long',
        blkSgrp2LblS: 'Block Sub Group 2 Label, Short',
        blkSgrp2LblL: 'Block Sub Group 2 Label, Long',
        blkLblL: 'Block Label, Long',
        blkLblS: 'Block Label, Short',
        defBlkAE: 'Default Next Block No',
        defBlkGrpAE: 'Default Next Block Group No.',
        defBlkSgrp1AE: 'Default Next Block Sub Group 1 No.',
        defBlkSgrp2AE: 'Default Next Block Sub Group 2 No.',
        nxtBlkGrpSeq: 'Next Block Group No.',
        nxtBlkSeq: 'Next Block No.',
        nxtBlkSgrp1Seq: 'Next Block Sub Group 1 No.',
        nxtBlkSgrp2Seq: 'Next Block Sub Group 2 No.',
        protBlkAE: 'Protect Block',
        protBlkGrpAE: 'Protect Block Group',
        protBlkSgrp1AE: 'Protect Block Sub Group 1',
        protBlkSgrp2AE: 'Protect Block Sub Group 2',
        rtnLimKey1: 'Retention Limit Key Factor 1',
        rtnLimKey2: 'Retention Limit Key Factor 2',
        rtnLimKey3: 'Retention Limit Key Factor 3',
        rtnLimKey4: 'Retention Limit Key Factor 4',
        rtnLimKey5: 'Retention Limit Key Factor 5',
        rtnLimKey6: 'Retention Limit Key Factor 6',
        useLimType: 'Apply Limit Type',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      accumTypeForm: {
        accmType: '',
        accmTypeDesc: '',
        blkGrpLblL: '',
        blkGrpLblS: '',
        blkSgrp1LblS: '',
        blkSgrp1LblL: '',
        blkSgrp2LblS: '',
        blkSgrp2LblL: '',
        blkLblL: '',
        blkLblS: '',
        defBlkAE: false,
        defBlkGrpAE: false,
        defBlkSgrp1AE: false,
        defBlkSgrp2AE: false,
        nxtBlkGrpSeq: 1,
        nxtBlkSeq: 1,
        nxtBlkSgrp1Seq: 1,
        nxtBlkSgrp2Seq: 1,
        protBlkAE: false,
        protBlkGrpAE: false,
        protBlkSgrp1AE: false,
        protBlkSgrp2AE: false,
        rtnLimKey1: '99',
        rtnLimKey2: '99',
        rtnLimKey3: '99',
        rtnLimKey4: '99',
        rtnLimKey5: '99',
        rtnLimKey6: '99',
        useLimType: false,
        createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      loading: false,
      submitting: false,
      rtnLimKey123List: [
        { code: '99', value: 'Not Applicable' },
        { code: 'CSVA', value: 'Cargo - Survey Agent' },
        { code: 'CSTA', value: 'Cargo - Settling Agent' },
        { code: 'CCOM', value: 'Cargo - Commodity' },
        { code: 'CPKG', value: 'Cargo - Packing' },
        { code: 'CVOY', value: 'Cargo - Voyage Area' },
        { code: 'FCON', value: 'Fire - Construction Class' },
        { code: 'FDIS', value: 'Fire - District Class' },
        { code: 'FOCC', value: 'Fire - Occupation Class' },
        { code: 'FOCL', value: 'Fire - Occupation Class Limit' },
        { code: 'HAGE', value: 'Health - Age Limit' },
        { code: 'HBSS', value: 'Health - Basis' },
        { code: 'HCHD', value: 'Health - Child Rate' },
        { code: 'HDED', value: 'Health - Deductible' },
        { code: 'HGRP', value: 'Health - Group Size' },
        { code: 'HPLN', value: 'Health - Plan' },
        { code: 'HGEN', value: 'Health - Gender' },
        { code: 'HTXN', value: 'Health - Transaction Code' },
        { code: 'PAGE', value: 'PA - Age Limit' },
        { code: 'POCC', value: 'PA - Occupation Class' },
        { code: 'POCG', value: 'PA - Occupation Group' },
        { code: 'POCP', value: 'PA - Occupation' },
        { code: 'PPLN', value: 'PA - Plan' },
        { code: 'PGEN', value: 'PA - Gender' },
        { code: 'RSI', value: 'Risk Sum Insured' },
        { code: 'INS', value: 'Insured' }
      ],
      rtnLimKey456List: [
        { code: '99', value: 'Not Applicable' },
        { code: 'CSVA', value: 'Cargo - Survey Agent' },
        { code: 'CSTA', value: 'Cargo - Settling Agent' },
        { code: 'CCOM', value: 'Cargo - Commodity' },
        { code: 'CPKG', value: 'Cargo - Packing' },
        { code: 'CVOY', value: 'Cargo - Voyage Area' },
        { code: 'FCON', value: 'Fire - Construction Class' },
        { code: 'FDIS', value: 'Fire - District Class' },
        { code: 'FOCC', value: 'Fire - Occupation Class' },
        { code: 'FOCL', value: 'Fire - Occupation Class Limit' },
        { code: 'HAGE', value: 'Health - Age Limit' },
        { code: 'HBSS', value: 'Health - Basis' },
        { code: 'HCHD', value: 'Health - Child Rate' },
        { code: 'HDED', value: 'Health - Deductible' },
        { code: 'HGRP', value: 'Health - Group Size' },
        { code: 'HPLN', value: 'Health - Plan' },
        { code: 'HGEN', value: 'Health - Gender' },
        { code: 'HTXN', value: 'Health - Transaction Code' },
        { code: 'PAGE', value: 'PA - Age Limit' },
        { code: 'POCC', value: 'PA - Occupation Class' },
        { code: 'POCG', value: 'PA - Occupation Group' },
        { code: 'POCP', value: 'PA - Occupation' },
        { code: 'PPLN', value: 'PA - Plan' },
        { code: 'PGEN', value: 'PA - Gender' },
        { code: 'RSI', value: 'Risk Sum Insured' },
        { code: 'INS', value: 'Insured' },
        { code: 'FD', value: 'Fund' },
        { code: 'DRI', value: 'Direct / RI Inwards' },
        { code: 'PT', value: 'Policy Type' }
      ]
    }
  },
  methods: {
    async doFetch() {
      const apiURI = this.accumTypeMenu.accumType
      if (apiURI) {
        this.loading = true
        try {
          const expand = { accumTypeReviewParam: this.accumTypeReviewParam }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.accumTypeForm.accmType = data.accumTypeReviewParam.accmType
            this.accumTypeForm.accmTypeDesc = data.accumTypeReviewParam.accmTypeDesc
            // Change if the label are empty in database
            // Needed to be defined while fetching
            // Otherwise, it will cause problem (NULL) when the DTO in backend processing the data
            if (data.accumTypeReviewParam.blkGrpLblL === undefined) {
              this.accumTypeForm.blkGrpLblL = ''
            } else {
              this.accumTypeForm.blkGrpLblL = data.accumTypeReviewParam.blkGrpLblL
            }
            if (data.accumTypeReviewParam.blkGrpLblS === undefined) {
              this.accumTypeForm.blkGrpLblS = ''
            } else {
              this.accumTypeForm.blkGrpLblS = data.accumTypeReviewParam.blkGrpLblS
            }
            if (data.accumTypeReviewParam.blkSgrp1LblS === undefined) {
              this.accumTypeForm.blkSgrp1LblS = ''
            } else {
              this.accumTypeForm.blkSgrp1LblS = data.accumTypeReviewParam.blkSgrp1LblS
            }
            if (data.accumTypeReviewParam.blkSgrp1LblL === undefined) {
              this.accumTypeForm.blkSgrp1LblL = ''
            } else {
              this.accumTypeForm.blkSgrp1LblL = data.accumTypeReviewParam.blkSgrp1LblL
            }
            if (data.accumTypeReviewParam.blkSgrp2LblS === undefined) {
              this.accumTypeForm.blkSgrp2LblS = ''
            } else {
              this.accumTypeForm.blkSgrp2LblS = data.accumTypeReviewParam.blkSgrp2LblS
            }
            if (data.accumTypeReviewParam.blkSgrp2LblL === undefined) {
              this.accumTypeForm.blkSgrp2LblL = ''
            } else {
              this.accumTypeForm.blkSgrp2LblL = data.accumTypeReviewParam.blkSgrp2LblL
            }
            if (data.accumTypeReviewParam.blkLblL === undefined) {
              this.accumTypeForm.blkLblL = ''
            } else {
              this.accumTypeForm.blkLblL = data.accumTypeReviewParam.blkLblL
            }
            if (data.accumTypeReviewParam.blkLblS === undefined) {
              this.accumTypeForm.blkLblS = ''
            } else {
              this.accumTypeForm.blkLblS = data.accumTypeReviewParam.blkLblS
            }
            this.accumTypeForm.defBlkAE = data.accumTypeReviewParam.defBlkAE
            this.accumTypeForm.defBlkGrpAE = data.accumTypeReviewParam.defBlkGrpAE
            this.accumTypeForm.defBlkSgrp1AE = data.accumTypeReviewParam.defBlkSgrp1AE
            this.accumTypeForm.defBlkSgrp2AE = data.accumTypeReviewParam.defBlkSgrp2AE
            this.accumTypeForm.nxtBlkGrpSeq = data.accumTypeReviewParam.nxtBlkGrpSeq
            this.accumTypeForm.nxtBlkSeq = data.accumTypeReviewParam.nxtBlkSeq
            this.accumTypeForm.nxtBlkSgrp1Seq = data.accumTypeReviewParam.nxtBlkSgrp1Seq
            this.accumTypeForm.nxtBlkSgrp2Seq = data.accumTypeReviewParam.nxtBlkSgrp2Seq
            this.accumTypeForm.protBlkAE = data.accumTypeReviewParam.protBlkAE
            this.accumTypeForm.protBlkGrpAE = data.accumTypeReviewParam.protBlkGrpAE
            this.accumTypeForm.protBlkSgrp1AE = data.accumTypeReviewParam.protBlkSgrp1AE
            this.accumTypeForm.protBlkSgrp2AE = data.accumTypeReviewParam.protBlkSgrp2AE
            this.accumTypeForm.rtnLimKey1 = data.accumTypeReviewParam.rtnLimKey1
            this.accumTypeForm.rtnLimKey2 = data.accumTypeReviewParam.rtnLimKey2
            this.accumTypeForm.rtnLimKey3 = data.accumTypeReviewParam.rtnLimKey3
            this.accumTypeForm.rtnLimKey4 = data.accumTypeReviewParam.rtnLimKey4
            this.accumTypeForm.rtnLimKey5 = data.accumTypeReviewParam.rtnLimKey5
            this.accumTypeForm.rtnLimKey6 = data.accumTypeReviewParam.rtnLimKey6
            this.accumTypeForm.useLimType = data.accumTypeReviewParam.useLimType
            this.accumTypeForm.createdBy = data.createdBy
            this.accumTypeForm.createdDate = data.createdDate
            this.accumTypeForm.modifiedBy = data.modifiedBy
            this.accumTypeForm.modifiedDate = data.modifiedDate
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'accumTypeList' })
    },
    async doCreate() {
      const apiURI = this.accumTypeMenu.createAccumType
      const form = this.accumTypeForm
      if (apiURI) {
        this.submitting = true
        try {
          // Starts here
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.accumTypeMenu.updateAccumType
      const form = this.accumTypeForm
      if (apiURI) {
        this.submitting = true
        try {
          // Starts here
          const result = await this.$http.put(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          } else {
            this.$toast.error('There was an error in saving accumulation type.')
          }
        }
        this.submitting = false
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    }
  },
  computed: {
    accumTypeMenu() {
      return this.$store.state.accumTypeParam.menu
    },
    accumTypeReviewParam() {
      return this.$route.params.accumTypeReviewParam
    },
    modeAccumType() {
      return this.$route.params.modeAccumType
    },
    disableBlockGroupLabelByShortAndDef: function () {
      if (this.accumTypeForm.blkGrpLblS === '') {
        return true
      } else {
        if (this.accumTypeForm.defBlkGrpAE === false) {
          return true
        } else {
          return false
        }
      }
    },
    disableBlockSubGroup1LabelByShortAndDef: function () {
      if (this.accumTypeForm.blkSgrp1LblS === '') {
        return true
      } else {
        if (this.accumTypeForm.defBlkSgrp1AE === false) {
          return true
        } else {
          return false
        }
      }
    },
    disableBlockSubGroup2LabelByShortAndDef: function () {
      if (this.accumTypeForm.blkSgrp2LblS === '') {
        return true
      } else {
        if (this.accumTypeForm.defBlkSgrp2AE === false) {
          return true
        } else {
          return false
        }
      }
    },
    disableBlockLabelByShortAndDef: function () {
      if (this.accumTypeForm.blkLblS === '') {
        return true
      } else {
        if (this.accumTypeForm.defBlkAE === false) {
          return true
        } else {
          return false
        }
      }
    },
    filterRetention1() {
      return this.rtnLimKey123List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey1
      })
    },
    filterRetention2() {
      return this.rtnLimKey123List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey2
      })
    },
    filterRetention3() {
      return this.rtnLimKey123List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey3
      })
    },
    filterRetention4() {
      return this.rtnLimKey456List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey4
      })
    },
    filterRetention5() {
      return this.rtnLimKey456List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey5
      })
    },
    filterRetention6() {
      return this.rtnLimKey456List.filter((list) => {
        return list.code === this.accumTypeForm.rtnLimKey6
      })
    },
    blkGrpLblSWatch() {
      return this.accumTypeForm.blkGrpLblS
    },
    blkSgrp1LblSWatch() {
      return this.accumTypeForm.blkSgrp1LblS
    },
    blkSgrp2LblSWatch() {
      return this.accumTypeForm.blkSgrp2LblS
    },
    blkLblSWatch() {
      return this.accumTypeForm.blkLblS
    },
    defBlkAEWatch() {
      return this.accumTypeForm.defBlkAE
    },
    defBlkGrpAEWatch() {
      return this.accumTypeForm.defBlkGrpAE
    },
    defBlkSgrp1AEWatch() {
      return this.accumTypeForm.defBlkSgrp1AE
    },
    defBlkSgrp2AEWatch() {
      return this.accumTypeForm.defBlkSgrp2AE
    }
  },
  watch: {
    blkGrpLblSWatch(value) {
      if (value === '') {
        this.accumTypeForm.defBlkGrpAE = false
        this.accumTypeForm.protBlkGrpAE = false
        this.accumTypeForm.blkGrpLblL = ''
        this.accumTypeForm.nxtBlkGrpSeq = 1
      }
    },
    blkSgrp1LblSWatch(value) {
      if (value === '') {
        this.accumTypeForm.defBlkSgrp1AE = false
        this.accumTypeForm.protBlkSgrp1AE = false
        this.accumTypeForm.blkSgrp1LblL = ''
        this.accumTypeForm.nxtBlkSgrp1Seq = 1
      }
    },
    blkSgrp2LblSWatch(value) {
      if (value === '') {
        this.accumTypeForm.defBlkSgrp2AE = false
        this.accumTypeForm.protBlkSgrp2AE = false
        this.accumTypeForm.blkSgrp2LblL = ''
        this.accumTypeForm.nxtBlkSgrp2Seq = 1
      }
    },
    blkLblSWatch(value) {
      if (value === '') {
        this.accumTypeForm.defBlkAE = false
        this.accumTypeForm.protBlkAE = false
        this.accumTypeForm.blkLblL = ''
        this.accumTypeForm.nxtBlkSeq = 1
      }
    },
    defBlkAEWatch(value) {
      if (value === false) {
        this.accumTypeForm.protBlkAE = false
        this.accumTypeForm.nxtBlkSeq = 1
      }
    },
    defBlkGrpAEWatch(value) {
      if (value === false) {
        this.accumTypeForm.protBlkGrpAE = false
        this.accumTypeForm.nxtBlkGrpSeq = 1
      }
    },
    defBlkSgrp1AEWatch(value) {
      if (value === false) {
        this.accumTypeForm.protBlkSgrp1AE = false
        this.accumTypeForm.nxtBlkSgrp1Seq = 1
      }
    },
    defBlkSgrp2AEWatch(value) {
      if (value === false) {
        this.accumTypeForm.protBlkSgrp2AE = false
        this.accumTypeForm.nxtBlkSgrp2Seq = 1
      }
    }
  },
  mounted() {},
  created() {
    if (this.accumTypeReviewParam === 'New') {
      this.newMode = true
    } else if (!this.accumTypeReviewParam) {
      this.doCancel()
    } else {
      if (this.modeAccumType === 'Query') {
        this.queryMode = true
        this.doFetch()
      } else if (this.modeAccumType === 'Review') {
        this.reviewMode = true
        this.doFetch()
      }
    }
  },
  mixins: [MessageMixin]
}
</script>
